import { connect } from 'react-redux';

// @ts-expect-error not migrated yet
import ShowUnpublishedChangesOnStartup from 'ContentEditorUI/components/messages/ShowUnpublishedChangesOnStartup';
// @ts-expect-error not migrated yet
import { getHasUnpublishedChanges } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { BLOG_TYPE_UNPUBLISH_CHANGES } from '../i18nConstants';
const mapStateToProps = state => ({
  contentNounKey: BLOG_TYPE_UNPUBLISH_CHANGES,
  hasUnpublishedChanges: getHasUnpublishedChanges(state)
});
export default connect(mapStateToProps)(ShowUnpublishedChangesOnStartup);